// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"305":"28c0924d","453":"3a4ae138"}[chunkId] + ".chunk.js";
};